import { HttpGetRequest } from '@infrastructure/axios/http-get-request';
import { IGetRecaptchaSiteKeyUseCase, RecaptchaSiteKey } from '../../interfaces';

export type OnRecaptchaUpdationSubscriber = (key: string) => void;

export abstract class AbstractGetRecaptchaSiteKeyUseCase extends HttpGetRequest<RecaptchaSiteKey> implements IGetRecaptchaSiteKeyUseCase {
  protected captchaKey: string;

  private subscriber: Optional<OnRecaptchaUpdationSubscriber>;

  constructor() {
    super();
    this.notify = this.notify.bind(this);
    this.subscribeToUpdate = this.subscribeToUpdate.bind(this);
  }

  public subscribeToUpdate(subscriber: OnRecaptchaUpdationSubscriber): Omit<AbstractGetRecaptchaSiteKeyUseCase, 'subscribeToUpdate'> {
    this.subscriber = subscriber;
    return this;
  }

  protected notify(key: string): Omit<AbstractGetRecaptchaSiteKeyUseCase, 'subscribeToUpdate' | 'notify'> {
    if (this?.subscriber) this.subscriber(key);
    return this;
  }

  abstract execute(): Promise<RecaptchaSiteKey>;
}

export default class GetRecaptchaSiteKeyUseCase extends AbstractGetRecaptchaSiteKeyUseCase {
  public async execute(): Promise<RecaptchaSiteKey> {
    const url = this.buildURL(`/auth/recaptcha-site-key`).get();
    const key = (await this.dispatch(url)).data.data;
    this.notify(key);
    return key;
  }
}
